(function($){
	/*
    jQuery('a.dropdown-toggle.nav-link').on('click', function(e) {        
        if(jQuery(this).data('href') && jQuery(this).data('href') !=="#" && jQuery(this).parent().children("ul.dropdown-menu.show").length){
            //console.log("goto" + jQuery(this).attr('href'));
            location.href = jQuery(this).data('href');
        }
    });
    */
    // Newsletter Banner
    $(document).ready(function() {
        checkNewsletterBannerCookie();
    });

    $("#btnCloseNewletterBanner").on('click', function(e){
        $("#NewsletterBanner").addClass('d-none');
        setCookie("STYXKEY_NewsletterBanner", "hide", 7);
    })

     // WP Facets - Hide Wrapper if no filter options exist
     document.addEventListener('facetwp-loaded', function() {
        const tabletWidth = window.matchMedia("(min-width: 768px)");

        $.each(FWP.settings.num_choices, function(key, val) {
            var $facet = $('.facetwp-facet-' + key);
            var $parent = $facet.closest('.facet-wrap');
            var $flyout = $facet.closest('.flyout-row');
            if ($parent.length || $flyout.length) {
                var $which = $parent.length ? $parent : $flyout;
                (0 === val) ? $which.hide() : $which.show();
            
                var bsCollapse = bootstrap.Collapse.getOrCreateInstance($facet.closest('.collapse'),{toggle: false});
                if(tabletWidth.matches) {
                    bsCollapse.show();
                } else {
                    bsCollapse.hide();
                }
            }
        });
    });
    // WP Facets - Hide Reset Button if no facets are selected
    $(document).on('facetwp-loaded', function() {
        var querystring = FWP.buildQueryString();
        if ( '' === querystring ) {
            $('.facet-reset').hide();
        }
        else {
            $('.facet-reset').show();
        }
    });

    // WP Facets - Hide Reset for search if empty
    $(document).on('facetwp-loaded', function() {
        var querystring = FWP.facets['search'];
        if ( querystring.length <= 0 ) {
            $('.facet-btn-search-reset').hide();
        } else {
            $('.facet-btn-search-reset').show();
        }
    });
    

})(jQuery);

    //  Set the Cookie
    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + "; " + expires +"; path=/";
    }

    // Get the Cookie
    function getCookie(cname) {
        var name = cname + "=";
        var ca   = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var  c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if ( c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function checkNewsletterBannerCookie() {
        // Get the cookie called "STYXKEY_NewsletterBanner"
        var visited = getCookie("STYXKEY_NewsletterBanner");

        if (getCookie("STYXKEY_NewsletterBanner") != "hide") {
            jQuery("#NewsletterBanner").removeClass('d-none');
        }
    }
